import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getPage } from 'modules/CMS/reducers';

const withContent = id => WrappedComponent => {
  class Component extends React.Component {
    componentDidMount () {
      this.props.getPage(id);
    }

    render () {
      return <WrappedComponent {...this.props.contents[id]} />;
    }
  }

  const mapStateToProps = state => ({
    contents: state.CMS.pages,
  });

  const mapDispatchToProps = dispatch =>
    bindActionCreators({ getPage }, dispatch);

  return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export default withContent;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/withContent/index.js